<template>
  <v-slide-y-transition mode="out-in">
    <div style="width: 100%; height: 100%; z-index: 0">


      <div ref="map" id="reqmap" style="width: 100%; height: 100%; z-index: 0"></div>


      <v-btn
        absolute
        dark
        fab
        bottom
        right
        color="pink"
        app
        style="margin-bottom: 20%"
        @click="addReq"
      >
        <v-icon>add</v-icon>
      </v-btn>


      <v-footer height="auto" fixed style="background-color: transparent;z-index: 5" v-show="isReqFormShow">

        <v-container fluid grid-list-md>
          <v-layout justify-center>
            <v-flex xs12 sm10 md8 lg6>
              <v-card ref="form">
                <v-card-title>
                  Snow Removal Request
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    label="Address"
                    placeholder="Optional"
                    v-model="address"
                    ref="address"
                    counter="100"
                    required
                  ></v-text-field>
                  <v-text-field
                    label="Comment"
                    placeholder="Optional"
                    v-model="comment"
                    ref="comment"
                  ></v-text-field>
                </v-card-text>
                <v-divider class="mt-1"></v-divider>
                <v-card-actions>
                  <v-btn flat
                         @click="cancelReq"
                  >Cancel</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" flat @click="submitReq">Submit</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-footer>

      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">locate your position</v-card-title>
            <v-card-text>Click the <i class="icon material-icons">location_on</i> button on the top left, or put your address manually</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat @click.native="dialog = false">I Know</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

    </div>

  </v-slide-y-transition>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<script>
  import dataPoints from '@/assets/js/datapoints.js'

  export default {
    name: 'Request',
    data: () => ({
      dialog:false,
      isReqFormShow:false,
      comment:'',
      address:'',
      curLat: '',
      curLng: ''
    }),
    created: function () {
      var options = {
        minOpacity: 0.5,
        maxZoomL: 20,
        max: 1.0,
        radius: 5,
        blur: 12
      }

      var pos=Math.floor(dataPoints.length*Math.random());
      var points=dataPoints.slice(0,pos)
      this.heat = L.heatLayer(points, options);
      this.layer = L.esri.basemapLayer('Topographic');
    },
    methods: {
      addReq:function () {
        this.isReqFormShow=true;
      },
      cancelReq:function () {
        this.isReqFormShow=false;
      },
      submitReq:function () {
        if(!(this.address)){
          this.dialog=true;
          return
        }
        this.address=''
        this.comment=''
        this.isReqFormShow=false;
      },
      addLocationBtn: function (map) {
        var lc = L.control.locate({
          position: 'topleft',
          strings: {
            title: "locate your position"
          },
          locateOptions: {
            enableHighAccuracy: true
          },
          icon: "icon material-icons",
          iconLoading: "icon material-icons red",
          iconElementTag: 'i',
          createButtonCallback: function (container, options) {
            var link = L.DomUtil.create('a', 'leaflet-bar-part leaflet-bar-part-single', container);
            link.title = options.strings.title;
            var icon = L.DomUtil.create(options.iconElementTag, options.icon, link);
            icon.innerHTML = "location_on"
            return {link: link, icon: icon};

          }
        }).addTo(map);
      },
      getAddress:function () {
        var self=this
        var url='https://maps.googleapis.com/maps/api/geocode/json?latlng='+self.curLat+','+self.curlng;
        $.ajax({
          type: 'GET',
          url: url,
          // data to be added to query string:
          data: { key: 'AIzaSyC9NstagKGzMogGYyPzYB6yUi5wAqdBpGQ' },
          // type of data we are expecting in return:
          dataType: 'json',
          timeout: 300,
          success: function(data){/*
            console.log(data)*/
            if(data && data.results){
              var addr= data.results[0].formatted_address
              self.address=addr.replace(/[0-9]/g, '');
            }
            console.log(self.address)
          },
          error: function(xhr, type, error){
            console.log(error)
          }
        })

      },
      onLocationFound: function (e) {
        self=this;
        var latlng = e.latlng;
        if (!latlng) {
          return
        }
        try {
          self.$nextTick(function () {
            self.curLat = latlng.lat;
            self.curlng = latlng.lng;
            console.log(self.curLat+', '+self.curlng)

            self.getAddress()
          })
        }catch (e){
          console.log(e)
        }
      }
    },
    mounted: function () {
      var self = this
      /*
      setInterval(function () {
        self.curLng=Date.now()
      },1000)*/
      var map = L.map('reqmap', {
        center: new L.LatLng(43.03, -76.14),
        zoom: 12,
        layers: [this.layer, this.heat]
      });
      map.on('locationfound', self.onLocationFound);
      self.addLocationBtn(map)
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Request.vue